import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
    name: 'user',
    initialState: {
        userData: null,
        selectedCatalog: null,
    },
    reducers: {
        setUserData: (state, action) => {
            state.userData = action.payload;
        },
        setSelectedCatalog: (state, action) => {
            state.selectedCatalog = action.payload;
        },
    },
});

export const { setUserData, setSelectedCatalog } = userSlice.actions;
export default userSlice.reducer;